export default function FormatsSection() {
  const trainingTypes = [
    { format: 'Тренинги', when: 'Когда нужна отработка конкретных навыков через практику', advantages: 'Высокая вовлечённость, быстрый результат, практическая направленность' },
    { format: 'Семинары', when: 'Когда нужно передать большой объём информации группе', advantages: 'Охват аудитории, структурированная подача, экспертный контент' },
    { format: 'Воркшопы', when: 'Когда команда решает конкретную бизнес-задачу', advantages: 'Практический результат, командная работа, немедленное применение' },
    { format: 'Бизнес-игры', when: 'Для развития стратегического мышления и командных навыков', advantages: 'Высокая вовлечённость, безопасная среда для экспериментов, развитие soft skills' },
    { format: 'Фасилитация', when: 'Когда нужно принять коллективное решение или провести стратегическую сессию', advantages: 'Эффективные решения, вовлечение всех участников, структурированный процесс' },
    { format: 'Наставничество', when: 'Для точечного развития конкретных сотрудников', advantages: 'Индивидуальный подход, передача опыта, долгосрочное развитие' },
    { format: 'Коучинг', when: 'Для раскрытия потенциала руководителей и ключевых сотрудников', advantages: 'Персональный рост, осознанность, устойчивые изменения' },
    { format: 'Онлайн обучение', when: 'Для распределённых команд и масштабирования обучения', advantages: 'Гибкость, экономия времени и бюджета, доступность' },
    { format: 'Смешанное обучение', when: 'Когда нужно сочетать глубину очного обучения с гибкостью онлайн', advantages: 'Лучшее из двух миров: очная практика + онлайн-поддержка' },
    { format: 'Микрообучение', when: 'Для поддержки навыков между основными модулями обучения', advantages: 'Быстрое усвоение, минимальные временные затраты, регулярность' }
  ];

  const timelineItems = [
    { title: 'Лидов много — продаж мало', desc: 'Трафик есть, заявки есть, а конверсия падает. Значит, пора обучать отдел продаж.' },
    { title: 'Конфликты между отделами', desc: 'Продажи и производство, маркетинг и логистика — когда коммуникация даёт сбой, обучение помогает наладить взаимодействие.' },
    { title: 'Новые руководители', desc: 'Сотрудника повысили, но управленческих навыков нет — классическая ситуация, требующая обучения.' },
    { title: 'Рост компании', desc: 'Масштабирование бизнеса требует новых компетенций от всей команды. Без обучения рост превращается в хаос.' },
    { title: 'Высокая текучесть', desc: 'Люди уходят туда, где есть развитие. Если текучесть растёт — пора вкладываться в обучение.' },
    { title: 'Низкая вовлечённость', desc: 'Сотрудники работают «на автомате», нет инициативы. Обучение возвращает интерес и мотивацию.' },
    { title: 'Появление новых продуктов', desc: 'Новый продукт требует новых знаний. Без обучения запуск может провалиться.' },
    { title: 'Изменение рынка', desc: 'Рынок изменился, а команда работает по-старому. Обучение — инструмент адаптации к новым реалиям.' }
  ];

  return (
    <>
      {/* Виды корпоративного обучения */}
      <section id="types" className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
            Виды корпоративного обучения
          </h2>
          <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
            Разные форматы для разных задач — выбирайте то, что подходит именно вашей команде
          </p>

          <div className="overflow-x-auto hidden md:block">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-teal-600 text-white">
                  <th className="p-4 text-left text-sm font-semibold rounded-tl-xl whitespace-nowrap">Формат</th>
                  <th className="p-4 text-left text-sm font-semibold whitespace-nowrap">Когда подходит</th>
                  <th className="p-4 text-left text-sm font-semibold rounded-tr-xl whitespace-nowrap">Преимущества</th>
                </tr>
              </thead>
              <tbody>
                {trainingTypes.map((type, i) => (
                  <tr key={i} className={`border-b border-gray-100 ${i % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-teal-50 transition-colors`}>
                    <td className="p-4 text-sm font-semibold text-gray-900 whitespace-nowrap">{type.format}</td>
                    <td className="p-4 text-sm text-gray-600">{type.when}</td>
                    <td className="p-4 text-sm text-gray-600">{type.advantages}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile card layout */}
          <div className="md:hidden space-y-3">
            {trainingTypes.map((type, i) => (
              <div key={i} className="bg-gray-50 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-block bg-teal-600 text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">{type.format}</span>
                </div>
                <p className="text-gray-500 text-xs mb-1">Когда подходит</p>
                <p className="text-gray-900 text-sm mb-3 leading-relaxed">{type.when}</p>
                <p className="text-gray-500 text-xs mb-1">Преимущества</p>
                <p className="text-gray-900 text-sm leading-relaxed">{type.advantages}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <a href="/" className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer">
              Подробнее о форматах обучения <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Когда компании понимают, что обучение необходимо */}
      <section id="formats" className="py-20 md:py-28 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
            Когда компании понимают, что обучение необходимо
          </h2>
          <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
            Существуют явные сигналы, которые говорят: пора инвестировать в развитие команды
          </p>

          <div className="max-w-3xl mx-auto relative">
            {/* Timeline line */}
            <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-0.5 bg-teal-200 transform md:-translate-x-px"></div>

            <div className="space-y-8">
              {timelineItems.map((item, i) => (
                <div key={i} className={`relative flex items-start gap-6 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                  {/* Dot */}
                  <div className="absolute left-6 md:left-1/2 w-4 h-4 bg-teal-600 rounded-full transform -translate-x-1/2 z-10 ring-4 ring-teal-100"></div>
                  {/* Content */}
                  <div className={`ml-14 md:ml-0 md:w-1/2 ${i % 2 === 0 ? 'md:pr-10 md:text-right' : 'md:pl-10'}`}>
                    <div className="bg-white p-6 rounded-xl">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                      <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                  {/* Spacer for alternating layout */}
                  <div className="hidden md:block md:w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}